import { Action } from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getProbeDomainKey } from '../../utils/keys/domain.key.js'

export const useCommitDomainTransfer = (options?: {
  useMutationOptions?: UseMutationOptions<Action, Error>
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, Error>(
    () => client.network.commitDomainTransfer(),
    {
      onSuccess: () => {
        const probeKey = getProbeDomainKey()
        queryClient.invalidateQueries(probeKey)
      },
      ...useMutationOptions,
    },
  )
}
